<template>
  <div class="roleadd" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据提交中..." element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div style="height:15px"></div>

    <div class="scenicList">
      <img class="fmt" :src="baseUrl+setDetail.img" />
      <div class="con">
        <h2>{{setDetail.title}}</h2>
        <p>营业时间：{{setDetail.business}}</p>
        <p>近期浏览：{{setDetail.read_num}}次</p>
      </div>
      <div class="level">景区等级：<font>{{setDetail.level}}</font>
      </div>
    </div>

    <ul class="lsls first">
      <li>
        <span>姓名</span>
        <input type="text" v-model="name" placeholder="请填写姓名"/>
      </li>
      <li>
        <span>联系电话</span>
        <input type="text" v-model="phone" placeholder="请填写联系电话"/>
      </li>
      <li>
        <span>用户邀请码</span>
        <input type="text" v-model="yqm" placeholder="请输入用户邀请码"/>
      </li>
      <li @click="showDrawer">
        <span>角色选择</span>
        <input type="text" readonly :name="active" placeholder="请选择角色选择" :value="msg"/>
      </li>

    </ul>

    <div style="height:50px"></div>
    <button class="addAddress" @click="saveUser">立即添加</button>


    <el-drawer
      title="选择角色" :visible.sync="drawer" :direction="direction" size="40%" :withHeader="true">
      <ul>
        <li @click="ce(0)">
          <p>超级管理员</p>
          <a v-if="0==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="0!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
        <li @click="ce(1)">
          <p>财务管理员</p>
          <a v-if="1==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="1!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
        <li @click="ce(2)">
          <p>普通管理员</p>
          <a v-if="1==active"><img src="~assets/images/choose2.png" /></a>
          <a v-if="1!=active"><img src="~assets/images/choose1.png" /></a>
        </li>
      </ul>
    </el-drawer>

  </div>
</template>

<script>
  import $ from 'jquery' //在需要使用的页面中
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        userData:[],
        name:'',
        phone:'',
        yqm:'',
        msg:'',
        direction: 'btt',
        drawer:false,
        active:-1,
        setDetail:[],
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
          WeixinJSBridge.call('hideOptionMenu');
      });
    },
    created(){
      this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
    },
    mounted() {
      this.beforeMount();
      this.getDetail();
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      ce:function(n){
        this.active = n;
        var msg = '';
        if(n == 0){
          msg = '超级管理员';
        }else if(n == 1){
          msg = '财务管理员';
        }else{
          msg = '普通管理员';
        }
        this.msg = msg;
        this.drawer = false;
      },
      showDrawer:function(){
        this.drawer = true;
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/index/spot',
          params:{
            id:id
          }
        }).then(function(response){
          var res = response.data.data;
          that.setDetail = res;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      saveUser:function(){
        var that = this;
        var s_id = that.$route.query.id;
        if(that.name == ''){
          that.$alert('请填写姓名!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.phone == ''){
          that.$alert('请填写联系电话!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.yqm == ''){
          that.$alert('请输入用户邀请码!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        if(that.active == -1){
          that.$alert('请选择角色!', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        that.fullscreenLoading = true;
        this.axios({
          method:'post',
          url:that.$host+'home/index/addRole',
          params:{
            name:that.name,
            yqm:that.yqm,
            phone:that.phone,
            s_id:s_id,
            role:that.active+1
          }
        }).then(function(response){
          that.fullscreenLoading = false;
          var res = response.data;
          if(res.status == 200){
            that.$router.go(-1)
          }else{
            that.$alert(res.message, '提示', {
              confirmButtonText: '确定'
            });
          }
          
        }).catch(err=>{
          that.fullscreenLoading = false;
            console.log('请求失败:'+err);
        });
        return false;
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .roleadd{
    max-width:640px;
    background:#f7faff;
    margin:0 auto;
  }

  .roleadd .scenicList{
    width:92%;
    margin:0 auto;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    background:#fff;
    border-radius:4px
  }
  .roleadd .scenicList img{
    float:left;
    width:35%;
    margin:10px;
    border-radius:4px
  }
  .roleadd .scenicList .con{
    float:left;
    width:55%;
    margin-top:10px;
  }
  .roleadd .scenicList .con h2{
    font-size:15px;
    color:#333;
    letter-spacing: 1px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .roleadd .scenicList .con p{
    font-size:14px;
    color:#666;
    margin-top:13px;
  }
  .roleadd .scenicList .level{
    clear:both;
    width:92%;
    margin:0 auto;
    font-size:15px;
    border-top:1px #fafafa solid;
    padding:10px 0 15px 0;
    color:#666
  }
  .roleadd .scenicList .level font{
    color:#f00;
    font-weight:bold;
  }
  .roleadd .scenicList .level a{
    float:right;
    background:#2F78FF;
    color:#fff;
    font-size:14px;
    border-radius:4px;
    padding:5px 8px;
    margin-top:-3px
  }

  .roleadd ul.lsls{
    display:block;
    width:92%;
    background:#fff;
    margin:0 auto;
    margin-bottom:50px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.01);
    border-radius: 4px;
    margin-top:15px;
  }
  .roleadd ul.first{
    margin-bottom:15px;
  }
  .roleadd ul.lsls li{
    width:92%;
    margin:0 auto;
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0;
    position: relative;
  }
  .roleadd ul.lsls li:last-child{
    border:none;
  }
  .roleadd ul.lsls li font{
    position:absolute;
    right:15px;
    bottom:15px;
    font-size:16px;
    color:#FF751A
  }
  .roleadd ul.lsls li .icon{
    position:absolute;
    right:10px;
    top:20px;
    width:8px
  }
  .roleadd ul li:first-child h2{
    font-size:18px
  }
  .roleadd li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .roleadd ul li span{
    display:block;
    width:100%;
    font-size:16px;
    padding-bottom:15px
  }
  .roleadd ul li input{
    display:block;
    width:100%;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    margin-top:1px;
  }
  .roleadd ul li .imgs{
    width:31%;
    margin-right:2%
  }
  .roleadd ul li .checkbox{
    float:right;
    width:auto !important;
    margin-right:30px;
    margin-top:4px
  }
  .roleadd ul li textarea{
    float:left;
    width:100%;
    height:80px;
    background:none;
    border:none;
    outline:none;
    font-size:15px;
    resize: none;
  }
  .roleadd .addAddress{
    display:block;
    margin:0 auto;
    width:80%;
    height:45px;
    border:none;
    background:#2F78FF;
    color:#fff;
    font-size:16px;
    border-radius:45px;
  }





  .roleadd .el-drawer__wrapper ul{
    width:90%;
    margin:0 auto;
  }
  .roleadd .el-drawer__wrapper li{
    border-bottom:solid 1px #EBF2FF;
    padding:15px 0 10px 0;
    position:relative;
  }
  .roleadd .el-drawer__wrapper li:last-child{
    border-bottom:none;
  }

  .roleadd .el-drawer__wrapper li p{
    padding-bottom:7px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding-left:45px;
  }
  .roleadd .el-drawer__wrapper li p:last-child{
    color: #666;
  }

  .roleadd .el-drawer__wrapper li a{
    position:absolute;
    left:0;
    top:50%;
    transform: translateY(-50%);
    color: #2F78FF;
    font-size:18px;
  }
  .roleadd .el-drawer__wrapper li a img{
    display:block;
    width:30px;
  }

</style>